import { useWindowDimensions } from './use-window-dimensions'

export const useIsMobile = () => {
  const { width } = useWindowDimensions()

  return { isMobile: width < 896 }
}
